import CityPageTemplate from "../city-template/CityPageTemplate";
import { weirtonConfig } from "./data";

export default function WeirtonPage() {
  return <CityPageTemplate config={weirtonConfig} />;
}